module.exports = __webpack_public_path__ + "static/tls_Logo-e3db2daf54b8d9921c6a36f127e4c38c.png";